<div class="dashboard">
  <aside class="sidebar-panel">
    <app-sidebar></app-sidebar>
  </aside>
  <div class="map-area">
    <app-map [lat]="45.501854" [lon]="11.614129" [zoom]="13" width="100%" height="100%">
    </app-map>
  </div>
</div>